import React, {Component} from 'react';
import Waypoint from "react-waypoint";
import growingLogo from "../../../images/growing.svg";
import tree from "../../../images/tree.svg";
import roots from "../../../images/roots.svg";
import grapes from "../../../images/grapes.svg";
import louie from "../../../images/louie.png";
import sarg_logo from "../../../images/Sargento-Corporate-Logo.png";
import sig from "../../../images/sig.png";
import "./Landing.css";

/**
 * Landing
 */
export default class Landing extends Component {

    /**
     * Constructor Landing
     *
     * @param props
     */
    constructor(props) {
        super(props);

        this.enterLanding = this.enterLanding.bind(this);
        this.leaveLanding = this.leaveLanding.bind(this);
    }

    /**
     * Enter landing
     */
    enterLanding() {
        this.props.setFamilyClassName('family');
        this.props.setHeader('OUR ROOTS', roots, 'Investing in the Sargento Family', false);
    }

    /**
     * Leave landing
     */
    leaveLanding() {
        this.props.setFamilyClassName('family spaced');
        this.props.setHeader('OUR ROOTS', roots, 'Investing in the Sargento Family', true);
    }

    /**
     * Render
     *
     * @returns {*}
     */
    render() {

        return (
            <Waypoint onEnter={this.enterLanding}
                      onLeave={this.leaveLanding}>

                <div className="landing">

                    <div className="top">
                        <div className="report_head">

                            <span>CORPORATE</span>

                            <span>
                                <img alt="" src={sarg_logo}
                                     className="sarg-logo"/>
                            </span>

                            <span>REPORT 2017</span>

                        </div>
                        <h1>GROWING<br/>FORWARD</h1>
                        <div className="icons">
                            <img alt="" src={roots}/>
                            <img alt="" src={grapes}/>
                            <img alt="" src={growingLogo}/>
                            <img alt="" src={tree}/>
                        </div>
                    </div>

                    <div className="letter">

                        <div className="ceo">
                            <img alt="" src={louie}/>
                        </div>
                        <article>
                            <p className="first_p">
                            In 2017, we celebrated important progress for our company. With this interactive report, we’re shining a spotlight on key moments, from how we expanded the Sargento family of employees to how we were awarded not only for our products, like new Sweet Balanced Breaks® cheese snacks, but also for our commitment to employees and creating a great workplace. 
                            </p>
                            <p>
                            We’ll share how we improved our facilities with the environment and efficiency in mind. And, we’ll showcase how we continued to strengthen our communities through volunteerism and charitable giving — including our best-ever year of the United Way campaign. Finally, we’ll recap many of the fun events that make the Sargento culture special. 
                            </p>
                            <p>
                            I am proud to reflect on our great progress in 2017 and look ahead to a bright future. Together, we are growing forward.  
                            </p>

                            <div className="signature">
                                <img alt="" src={sig}/>
                                <span>Louie Gentine</span>
                                <span>Chief Executive Officer</span>
                            </div> 
                        </article>
                    </div>
        
                </div>
            </Waypoint>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/Pages/Landing/Landing.jsx